import { useCallback, useEffect, useState } from 'react'

// estilos
import './taskNewMobilev1.css'
import './tasksWorkspace.css'
import '../../assets/style/componentPrincipal.css'
import { Model } from '../../models/model'
import { Link } from 'react-router-dom'
import { TaskOneMovil } from './TaskOneMovil'
import { ModalProgress } from '../modals/ModalProgress'
import { DialogFormMovil } from './DialogFormMovil'
import { useSelector } from 'react-redux'

export const TasksListNewMobile = () => {

    const { perfil } = useSelector(state => state.auth)

    const [openProgress, setOpenProgress] = useState(true)
    const [openSearch, setOpenSearch] = useState(false)
    const [openFormMovil, setOpenFormMovil] = useState(false)
    const [selectedId, setSelectedId] = useState(0)

    const [taskList, setTaskList] = useState([])
    const [filters, setFilters] = useState({
        estado: '',
        text: '',
        time: 'today',
        page: 1,
        rows: 20,
        perfil: perfil
    })

    const handleGetTasks = useCallback(async () => {
        const params = new URLSearchParams(filters).toString()
        const results = await Model.getAll({ url: `tasks/movil/?${params}` })
        setTaskList(results || [])
        setOpenProgress(false)
    }, [filters])

    const handleOpenSearch = async () => {
        const newState = !openSearch
        setOpenSearch(newState)

        if (!newState) {
            setFilters({
                ...filters,
                text: ''
            })
        }

    }

    const handleNewTask = async () => {
        setSelectedId(0)
        setOpenFormMovil(true)
    }

    useEffect(() => {
        handleGetTasks()
    }, [handleGetTasks])

    return (
        <>

            {openFormMovil ?
                <DialogFormMovil
                    open={openFormMovil}
                    setOpen={setOpenFormMovil}
                    taskId={selectedId}
                    refreshObj={{
                        fn_: handleGetTasks,
                        filters_: filters
                    }}
                /> :
                ''
            }

            {openProgress ?
                <ModalProgress />
                :
                <div className='container-fluid animate__animated animate__fadeIn mb-5 tasks-workspace tasks-workspace-mobile'>

                    <header className='tasks-page-heading'>
                        <h1 className='text-[#595759] text-[20px] font-semibold mt-[15px] mb-[20px]'>Tareas</h1>
                        <Link to="" className='ms-3 text-[#8E24AA] text-[14px] hover:underline hover:text-[#8E24AA]' onClick={handleOpenSearch}>
                            <i className="bi bi-search text-[13px]"></i>
                            <span className='ms-1'>Buscar</span>
                        </Link>
                        <Link
                            to=""
                            onClick={handleNewTask}
                            className='btn tasks-mobile-create'>
                            + Nueva tarea
                        </Link>
                    </header>

                    {openSearch &&
                        <div className='border rounded'>
                            <input
                                className='p-2 rounded-lg w-full text-lg focus:outline-none'
                                type="search"
                                aria-label="Buscar tareas"
                                placeholder='buscar por palabra clave'
                                onChange={(e) => setFilters({ ...filters, text: e.target.value })}
                                autoFocus
                            />
                        </div>
                    }

                    <div className='p-box-filters mb-3'>
                        <div className='p-box-filters-items'>
                            <Link
                                to=""
                                className={filters.time === 'all' ? 'selected' : ''}
                                onClick={() => setFilters({ ...filters, time: 'all' })}
                            >Todos</Link>

                            <Link
                                to=""
                                className={filters.time === 'today' ? 'selected' : ''}
                                onClick={() => setFilters({ ...filters, time: 'today' })}
                            >Hoy</Link>

                            <Link
                                to=""
                                className={filters.time === 'week' ? 'selected' : ''}
                                onClick={() => setFilters({ ...filters, time: 'week' })}
                            >Esta semana</Link>

                            <Link
                                to="" className={filters.time === 'late' ? 'selected' : ''}
                                onClick={() => setFilters({ ...filters, time: 'late' })}
                            >Vencidas</Link>
                        </div >
                    </div>

                    <div>
                        <BoxTaskGeneral
                            tasks={taskList}
                            setSelectedId={setSelectedId}
                            setOpenFormMovil={setOpenFormMovil}
                        />
                        <h3 className='mt-10 text-center text-[#595759] text-[14px]'>
                            {(taskList.length === 0 && filters.time === 'all') && 'No se encontraron tareas'}
                            {(taskList.length === 0 && filters.time === 'today') && 'No hay tareas para hoy'}
                            {(taskList.length === 0 && filters.time === 'week') && 'No hay tareas para esta semana'}
                            {(taskList.length === 0 && filters.time === 'late') && 'No hay tareas atrasadas'}
                        </h3>
                    </div>

                </div>
            }

        </>
    )
}

const BoxTaskGeneral = ({ tasks, setSelectedId, setOpenFormMovil }) => {

    const handleOpenForm = (taskId) => {
        setSelectedId(taskId)
        setOpenFormMovil(true)
    }

    return (
        <>
            {tasks.map(item => {
                return (
                    <Link
                        to=""
                        onClick={() => handleOpenForm(item.id)}
                        key={item.id}
                        className='tasks-mobile-link'
                    >
                        <TaskOneMovil
                            key={item.id}
                            task={item}
                            from='tasklist'
                        />
                    </Link>

                )
            })}
        </>
    )
}

